export default __webpack_public_path__ + "static/media/shop-product-image.609795b9.png";